import React from 'react'

const About = () => {
  return (
    <div className='mx-auto my-16'> 
        <div className='flex font-extrabold text-2xl justify-center'>
            <p>Hey 👋</p>
        </div>
        <div className='flex font-bold text-xl justify-center pt-2'>
            <p>Myself Nilesh, Nice to Meet You! </p>
        </div>
        <div className='flex font-medium text-sm lg:text-lg mx-7 sm:mx-12 md:mx-28 lg:mx-36 xl:mx-48 flex-col items-center justify-center pt-2 italic'>
        <p>I always like to do crazy things with programming and I have at least learnt something, I think… 🤷‍♂️</p>

        <p>My field of Interest's are building new Web Technologies and Products</p>

        <p>A passionate Full Stack Software Developer 🚀</p>
        <p>I have an experience of building Web and Mobile applications with
JavaScript, Reactjs, Nodejs, React Native and some other cool libraries</p>
        </div>
    </div>
  )
}

export default About;
